import store from "../index.js";
import api from "../../utils/api";

export const modules = {
  store,
};

export const state = {
  _items: [],
  _item: {},
  _page: {}, // { pageSize, totalCount, totalPage }
};

export const mutations = {
  setIndivCreditList(state, item) {
    state._items = [];
    state._items = item.items;
    state._page = item.page;
  },
  setIndivCreditDetail(state, item) {
    state._item = item;
  },
};

export const actions = {
  async acListIndivCredit(
    { commit },
    { stdate, endate, page, pageSize, email, status }
  ) {
    const url = "/api/v1/credit/indiv";
    try {
      const res = await api.get(`${url}`, {
        params: { stdate, endate, page, pageSize, email, status },
      });
      if (res.data?.code === 0 && res.data.data) {
        const page = {
          pageSize: res.data.data.pageSize,
          totalCount: res.data.data.resultCount,
          totalPage: res.data.data.totalPage,
        };
        window.console.log("acListIndivCredit, res: ", res);
        commit("setIndivCreditList", {
          page: page,
          items: res.data.data.results,
        });
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acGetIndivCreditDetail({ commit }, { report_seq }) {
    const url = `/api/v1/credit/indiv/${report_seq}`;
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit("setIndivCreditDetail", res.data.data);
        return true;
      } else {
        commit("setIndivCreditDetail", null);
        return false;
      }
    } catch (error) {
      commit("setIndivCreditDetail", null);
      return false;
    }
  },
  async acResetIndivCredit({ commit }, { report_seq }) {
    const url = `/api/v1/credit/indiv/reset/${report_seq}`;
    try {
      const res = await api.post(`${url}`);
      window.console.log("acResetIndivCredit, res: ", res);
      return {
        success: res.data?.code === 0 && res.data?.data !== null,
        message: res.data?.message,
      };
    } catch (error) {
      window.console.log("acResetIndivCredit, error: ", error);
      return {
        success: false,
        message: error.data?.message,
      };
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
